// Validation utilities

// Check if value is blank or "Unknown"
export const isBlankOrUnknown = (v) =>
  !v || String(v).trim() === '' || String(v).trim().toLowerCase() === 'unknown'

// Basic email validation
export const isValidEmail = (email) => {
  if (!email) return false
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email.trim())
}

// Phone validation (10 digits after cleaning)
export const isValidPhone = (phone) => {
  if (!phone) return false
  const digits = phone.replace(/\D/g, '')
  // Allow 10 digits or 11 digits starting with 1
  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))
}

// Name validation (non-empty, letters and spaces only)
export const isValidName = (name) => {
  if (!name) return false
  const trimmed = name.trim()
  // Allow letters, spaces, hyphens, and apostrophes
  return trimmed.length > 0 && /^[a-zA-Z\s'-]+$/.test(trimmed)
}

// ZIP code validation (5 digits)
export const isValidZip = (zip) => {
  if (!zip) return false
  return /^\d{5}(-\d{4})?$/.test(zip.trim())
}

// Address validation (non-empty, has street number and letters, reasonable length)
export const isValidAddress = (address) => {
  if (!address) return false
  const trimmed = address.trim()
  // Must be at least 5 chars (e.g., "1 A St")
  if (trimmed.length < 5) return false
  // Must contain at least one number (street number)
  if (!/\d/.test(trimmed)) return false
  // Must contain at least one letter (street name)
  if (!/[a-zA-Z]/.test(trimmed)) return false
  return true
}

// DOB validation (reasonable age range)
export const isValidDob = (month, day, year) => {
  if (!month || !day || !year) return false

  const m = parseInt(month, 10)
  const d = parseInt(day, 10)
  const y = parseInt(year, 10)

  // Basic range checks
  if (m < 1 || m > 12) return false
  if (d < 1 || d > 31) return false
  if (y < 1900 || y > new Date().getFullYear()) return false

  // Check valid date
  const date = new Date(y, m - 1, d)
  if (date.getMonth() !== m - 1) return false

  // Check age is at least 18
  const today = new Date()
  const age = today.getFullYear() - y -
    (today.getMonth() < m - 1 || (today.getMonth() === m - 1 && today.getDate() < d) ? 1 : 0)

  return age >= 18 && age <= 120
}
